import { toCamelCase } from '@/utils/utils';
import { PlanGroup, productToProductName, ProductType } from '@d-id/types';

export const formattedDate = (date: Date) => date.toLocaleDateString('en-EN', { year: 'numeric', month: 'short', day: 'numeric' });

export const productName = (planName: ProductType | PlanGroup) => toCamelCase(productToProductName[planName]);
